export const portalEventTranslations = {
  "de": {
    "created": "Ticket erstellt",
    "reply_added": "Öffentliche Antwort hinzugefügt",
    "status_changed": "Status geändert",
    "reopened": "Ticket wieder geöffnet",
    "handoff": "An externen Partner übergeben",
    "partner_replied": "Rückmeldung des externen Partners",
    "solution_proposed": "Lösung durch externen Partner vorgeschlagen",
    "solution_rejected": "Lösungsvorschlag wird weiter bearbeitet",
    "cancelled": "Partnerübergabe beendet",
    "switched": "Externen Partner gewechselt",
    "updated": "Ticket aktualisiert",
    "portal": "Kundenportal",
    "status": "Status"
  },
  "en": {
    "created": "Ticket created",
    "reply_added": "Public reply added",
    "status_changed": "Status changed",
    "reopened": "Ticket reopened",
    "handoff": "Handed over to external partner",
    "partner_replied": "External partner replied",
    "solution_proposed": "External partner proposed a solution",
    "solution_rejected": "Solution requires further work",
    "cancelled": "Partner handoff ended",
    "switched": "External partner changed",
    "updated": "Ticket updated",
    "portal": "Customer portal",
    "status": "Status"
  },
  "fr": {
    "created": "Ticket créé",
    "reply_added": "Réponse publique ajoutée",
    "status_changed": "Statut modifié",
    "reopened": "Ticket rouvert",
    "handoff": "Transmis au partenaire externe",
    "partner_replied": "Réponse du partenaire externe",
    "solution_proposed": "Solution proposée par le partenaire externe",
    "solution_rejected": "Solution à retravailler",
    "cancelled": "Transfert au partenaire terminé",
    "switched": "Partenaire externe changé",
    "updated": "Ticket mis à jour",
    "portal": "Portail client",
    "status": "Statut"
  },
  "es": {
    "created": "Ticket creado",
    "reply_added": "Respuesta pública añadida",
    "status_changed": "Estado cambiado",
    "reopened": "Ticket reabierto",
    "handoff": "Transferido al proveedor externo",
    "partner_replied": "Respuesta del proveedor externo",
    "solution_proposed": "Solución propuesta por el proveedor externo",
    "solution_rejected": "La solución requiere más trabajo",
    "cancelled": "Transferencia al proveedor finalizada",
    "switched": "Proveedor externo cambiado",
    "updated": "Ticket actualizado",
    "portal": "Portal del cliente",
    "status": "Estado"
  },
  "pt": {
    "created": "Ticket criado",
    "reply_added": "Resposta pública adicionada",
    "status_changed": "Estado alterado",
    "reopened": "Ticket reaberto",
    "handoff": "Encaminhado ao parceiro externo",
    "partner_replied": "Resposta do parceiro externo",
    "solution_proposed": "Solução proposta pelo parceiro externo",
    "solution_rejected": "A solução requer mais trabalho",
    "cancelled": "Encaminhamento ao parceiro terminado",
    "switched": "Parceiro externo alterado",
    "updated": "Ticket atualizado",
    "portal": "Portal do cliente",
    "status": "Estado"
  },
  "nl": {
    "created": "Ticket aangemaakt",
    "reply_added": "Openbaar antwoord toegevoegd",
    "status_changed": "Status gewijzigd",
    "reopened": "Ticket heropend",
    "handoff": "Overgedragen aan externe partner",
    "partner_replied": "Antwoord van externe partner",
    "solution_proposed": "Oplossing voorgesteld door externe partner",
    "solution_rejected": "Oplossing vereist verdere uitwerking",
    "cancelled": "Overdracht aan partner beëindigd",
    "switched": "Externe partner gewijzigd",
    "updated": "Ticket bijgewerkt",
    "portal": "Klantenportaal",
    "status": "Status"
  },
  "pl": {
    "created": "Utworzono zgłoszenie",
    "reply_added": "Dodano publiczną odpowiedź",
    "status_changed": "Zmieniono status",
    "reopened": "Ponownie otwarto zgłoszenie",
    "handoff": "Przekazano partnerowi zewnętrznemu",
    "partner_replied": "Odpowiedź partnera zewnętrznego",
    "solution_proposed": "Partner zewnętrzny zaproponował rozwiązanie",
    "solution_rejected": "Rozwiązanie wymaga dalszych prac",
    "cancelled": "Zakończono przekazanie partnerowi",
    "switched": "Zmieniono partnera zewnętrznego",
    "updated": "Zaktualizowano zgłoszenie",
    "portal": "Portal klienta",
    "status": "Status"
  },
  "ru": {
    "created": "Заявка создана",
    "reply_added": "Добавлен публичный ответ",
    "status_changed": "Статус изменён",
    "reopened": "Заявка открыта повторно",
    "handoff": "Передано внешнему партнёру",
    "partner_replied": "Ответ внешнего партнёра",
    "solution_proposed": "Внешний партнёр предложил решение",
    "solution_rejected": "Решение требует доработки",
    "cancelled": "Передача партнёру завершена",
    "switched": "Внешний партнёр изменён",
    "updated": "Заявка обновлена",
    "portal": "Клиентский портал",
    "status": "Статус"
  },
  "be": {
    "created": "Ticket aangemaakt",
    "reply_added": "Openbaar antwoord toegevoegd",
    "status_changed": "Status gewijzigd",
    "reopened": "Ticket heropend",
    "handoff": "Overgedragen aan externe partner",
    "partner_replied": "Antwoord van externe partner",
    "solution_proposed": "Oplossing voorgesteld door externe partner",
    "solution_rejected": "Oplossing vereist verdere uitwerking",
    "cancelled": "Overdracht aan partner beëindigd",
    "switched": "Externe partner gewijzigd",
    "updated": "Ticket bijgewerkt",
    "portal": "Klantenportaal",
    "status": "Status"
  }
};
